import React from 'react';
import PropTypes from 'prop-types';
import { Image, Text, Flex, Box } from 'rebass';
import { StaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import Fade from 'react-reveal/Fade';
import { CardContainer, Card } from './Card';
import SocialLink from './SocialLink';
import ImageSubtitle from './ImageSubtitle';
import Img from 'gatsby-image'
const CARD_HEIGHT = '250px';

const MEDIA_QUERY_SMALL = '@media (max-width: 400px)';

const Title = styled(Text)`
  font-size: 14px;
  font-weight: 900;
  text-transform: uppercase;
  display: table;
  border-bottom: '#7c37ad' 5px solid;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px;
  width: calc(100% - ${CARD_HEIGHT});

  ${MEDIA_QUERY_SMALL} {
    width: calc(100% - (${CARD_HEIGHT} / 2));
  }
`;

const ImageContainer = styled.div`
  margin: auto;
  width: ${CARD_HEIGHT};
  height: ${CARD_HEIGHT};
  ${MEDIA_QUERY_SMALL} {
    width: calc(${CARD_HEIGHT} / 2);
  }
`;


const ProjectTag = styled.div`
  position: relative;
  height: ${CARD_HEIGHT};
  top: calc(
    -${CARD_HEIGHT}
  );

  ${MEDIA_QUERY_SMALL} {
    top: calc(-${CARD_HEIGHT} - 3.5px + (${CARD_HEIGHT} / 4));
  }
`;

const ToolsContainer = styled.div`
    width: 25px;
    height: ${CARD_HEIGHT}/2;
`;

const Project = ({
  name,
  description,
  projectUrl,
  repositoryUrl,
  type,
  publishedDate,
  tools,
  mainimage,
}) => (
  <Card p={3}>
    <Flex style={{ height: CARD_HEIGHT }}>
      <TextContainer>
        <span>
          <Title my={2} pb={1}>
            {name}
          </Title>
        </span>
        <Text width={[1]} style={{ overflow: 'auto' }}>
          {description}
        </Text>
      </TextContainer>
      <ToolsContainer>
        <Flex
          style={{
            flexDirection: 'column-reverse',
            flex: 1,
            height: '60%',
          }}
        >
          <Box mx={1} fontSize={5}>
            <SocialLink
              name={tools.tool_1.name}
              url={tools.tool_1.url}
              altImg={tools.tool_1.altImg}
            />
          </Box>
          <Box mx={1} fontSize={5}>
            <SocialLink
              name={tools.tool_2.name}
              url={tools.tool_2.url}
              altImg={tools.tool_2.altImg}
            />
          </Box>
          <Box mx={1} fontSize={5}>
            <SocialLink
              name={tools.tool_3.name}
              url={tools.tool_3.url}
              altImg={tools.tool_3.altImg}
            />
          </Box>
        </Flex>
      </ToolsContainer>
      <ImageContainer>
        <Img
          fluid={mainimage.childImageSharp.fluid}
        />
        <ProjectTag>
          <Flex
            style={{
              float: 'right',
            }}
          >
            <Box mx={1} fontSize={5}>
              <SocialLink
                name="Check repository"
                iconType="fab"
                fontAwesomeIcon="github-square"
                url={repositoryUrl}
              />
            </Box>
          </Flex>
          <ImageSubtitle bg='#FF9400' color='#000000' round>{publishedDate}</ImageSubtitle>
          <ImageSubtitle bg='#FFCA00' color="#000000" y="bottom" x="right" round>{type}</ImageSubtitle>
        </ProjectTag>
      </ImageContainer>
    </Flex>
  </Card>
);
Project.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  projectUrl: PropTypes.string.isRequired,
  repositoryUrl: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  publishedDate: PropTypes.string.isRequired,
  mainimage: PropTypes.object.isRequired,
  title: PropTypes.string,
  tools: PropTypes.object,
};

const Projects = () => (
  <StaticQuery
    query={graphql`
        query ProjectsQuery {
          allGithubProjectCardsYaml (sort: {order: DESC, fields: publishedDate}) {
            edges {
              node {
                id
                name
                description
                projectUrl
                repositoryUrl
                publishedDate(formatString: "YYYY")
                type
                mainimage {
                  childImageSharp {
                    fluid(maxHeight: 1000, maxWidth: 1000) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                tools {
                  tool_1 {
                    name
                    url
                    altImg {
                      childImageSharp {
                        fluid(maxHeight: 1000, maxWidth: 1000) {
                          ...GatsbyImageSharpFluid
                        }
                      }
                    }
                  }
                  tool_2 {
                    name
                    url
                    altImg {
                      childImageSharp {
                        fluid(maxHeight: 1000, maxWidth: 1000) {
                          ...GatsbyImageSharpFluid
                        }
                      }
                    }
                  }
                  tool_3 {
                    name
                    url
                    altImg {
                      childImageSharp {
                        fluid(maxHeight: 1000, maxWidth: 1000) {
                          ...GatsbyImageSharpFluid
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `}
    render={({ allGithubProjectCardsYaml }) => (
      <CardContainer minWidth="350px">
        {allGithubProjectCardsYaml.edges.map((p, i) => (
          <Fade bottom delay={i * 200} key={p.node.id}>
            <Project {...p.node} />
          </Fade>
        ))}
      </CardContainer>
    )}
  />
);

export default Projects;
